import { render, staticRenderFns } from "./yupload.vue?vue&type=template&id=144afea9&scoped=true&"
import script from "./yupload.vue?vue&type=script&lang=js&"
export * from "./yupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144afea9",
  null
  
)

export default component.exports